import { Component, ElementRef, ViewChild } from '@angular/core';
import { ProctorService } from '../services/proctor.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-await-proctor',
  templateUrl: './await-proctor.component.html',
  styleUrls: ['./await-proctor.component.css']
})
export class AwaitProctorComponent {
  showVideo: boolean = true;
  examStarted: boolean = false;
  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvasElement') canvasElement!: ElementRef<HTMLCanvasElement>;
  proctorError$: string | null;

  constructor(private proctorService: ProctorService) {

  }
  ngOnInit(): void {

  }

  async ngAfterViewInit() {
    const candidateVideo = await this.proctorService.getVideoStream(false);
    if (candidateVideo && this.videoElement && this.videoElement.nativeElement) {
      this.videoElement.nativeElement.srcObject = candidateVideo;
      this.videoElement.nativeElement.style.transform = 'scaleX(-1)';
      this.videoElement.nativeElement.muted = true;
    }

    window.addEventListener('message', (event) => {
      if (event.data.type === 'proctorError') {
        console.log('Error received:', event.data.error);
        this.showVideo = false;
        if (this.videoElement && this.videoElement.nativeElement && this.videoElement.nativeElement.srcObject) {
          const stream = this.videoElement.nativeElement.srcObject as MediaStream;
          stream.getTracks().forEach(track => track.stop());
          this.videoElement.nativeElement.srcObject = null;
        }
        this.proctorError$ = event.data.error;

      }
    });
    
  }

  // onStartExam() {
  //   this.proctorService.startExamClicked = true;
  //   window.parent.postMessage({ type: 'takeExamClicked', clicked: true }, '*');
  //   this.examStarted = true;
  // }
  restartProcess(){
    if (window.self !== window.top) {
      // We are in an iframe, reload the parent
      window.top?.location.reload();
    } else {
      // We are not in an iframe, reload current page
      window.location.reload();
    }
  }
  ngOnDestroy(): void {
    
  }
}
